import { servicesSlides } from "./services.config";

export const serviceTimeline = servicesSlides.flatMap(
  (category, categoryIndex) =>
    category.slides.map((slide, slideIndex) => ({
      category,
      categoryIndex,
      slide,
      slideIndex,
    }))
);

export const categoryStartIndexes = servicesSlides.map((_, categoryIndex) =>
  servicesSlides
    .slice(0, categoryIndex)
    .reduce((total, category) => total + category.slides.length, 0)
);

/**
 * Scrolls a pinned, scroll-driven story (offset ["start start", "end end"])
 * so that the given step becomes active. It jumps instantly: smooth
 * scrolling would play every intermediate step on the way.
 */
export function scrollToStoryStep(
  story: HTMLElement,
  step: number,
  totalSteps: number
) {
  const top = story.getBoundingClientRect().top + window.scrollY;
  const travel = story.offsetHeight - window.innerHeight;
  const progress = (step + 0.05) / totalSteps;

  window.scrollTo({ top: top + travel * progress, behavior: "auto" });
}
